export default {
  "b2b.smlouvy-grid-columns.cislo.label": "Number",
  "b2b.smlouvy-grid-columns.popis.label": "Description",
  "b2b.smlouvy-grid-columns.fixniMZO.label": "Fixed STR",
  "b2b.smlouvy-grid-columns.fixniVZO.label": "Fixed LTR",
  "b2b.smlouvy-grid-columns.platnostOd.label": "Validity from",
  "b2b.smlouvy-grid-columns.platnostDo.label": "Validity to"
};
